import './styles/main.css';
import { renderSidebar, requireAuth } from './components/layout.js';
import { navigate } from './utils/router.js';
import { LoginPage, RegisterPage } from './pages/auth.js';
import { DashboardPage } from './pages/dashboard.js';
import { BranchesPage } from './pages/branches.js';
import { ServicesPage } from './pages/services.js';
import { UsersPage } from './pages/users.js';
import { RegistrationsPage } from './pages/registrations.js';
import { ProfilePage } from './pages/profile.js';
import { AuditPage } from './pages/audit.js';
import { SessionsPage } from './pages/sessions.js';

const ROUTES = {
  '/login': { handler: () => LoginPage(), auth: false, sidebar: false },
  '/register': { handler: () => RegisterPage(), auth: false, sidebar: false },
  '/dashboard': { handler: (u) => DashboardPage(u), auth: true, sidebar: true },
  '/branches': { handler: (u) => BranchesPage(u), auth: true, sidebar: true, roles: ['admin'] },
  '/services': { handler: (u) => ServicesPage(u), auth: true, sidebar: true, roles: ['admin', 'instructor'] },
  '/users': { handler: (u) => UsersPage(u), auth: true, sidebar: true, roles: ['admin'] },
  '/registrations': { handler: (u) => RegistrationsPage(u), auth: true, sidebar: true, roles: ['admin'] },
  '/sessions': { handler: (u) => SessionsPage(u), auth: true, sidebar: true },
  '/profile': { handler: (u) => ProfilePage(u), auth: true, sidebar: true },
  '/audit': { handler: () => AuditPage(), auth: true, sidebar: true, roles: ['admin'] },
};

let pending = null;

const route = async (path) => {
  const def = ROUTES[path];
  if (!def) {
    navigate('/dashboard');
    return;
  }
  if (def.auth) {
    const user = await requireAuth(def.roles || null);
    if (!user) return;
    renderSidebar(path);
    await def.handler(user);
  } else {
    renderSidebar(path);
    await def.handler();
  }
};

window.addEventListener('routechange', (e) => {
  const path = e.detail;
  if (pending) return;
  pending = true;
  requestAnimationFrame(() => { pending = false; route(path); });
});

window.addEventListener('popstate', () => {
  const path = window.location.pathname || '/';
  if (path === '/') {
    const token = localStorage.getItem('tiq_token');
    if (token) navigate('/dashboard');
    else navigate('/login');
    return;
  }
  window.dispatchEvent(new CustomEvent('routechange', { detail: path }));
});

window.addEventListener('load', () => {
  const path = window.location.pathname || '/';
  if (path === '/') {
    const token = localStorage.getItem('tiq_token');
    navigate(token ? '/dashboard' : '/login');
    return;
  }
  window.dispatchEvent(new CustomEvent('routechange', { detail: path }));
});
